import React from 'react'

import { Button, Icon } from '@fourthwall/components'

import { getIcon } from '../../utils/getIcon'
import * as S from './styled'
import type { Props } from './types'
import { getDescription } from './utils/getDescription'

export const SectionItem = ({ section, onButtonClick }: Props) => {
  const { sectionType, name, additionalInfo } = section

  return (
    <S.Item>
      <S.Container>
        <S.Wrapper>
          <Icon component={getIcon(sectionType)} height={24} />
        </S.Wrapper>
        <S.Text>
          <span>{name}</span>
          <S.Description>
            {additionalInfo?.description || getDescription(sectionType)}
          </S.Description>
        </S.Text>
      </S.Container>

      <S.Wrapper>
        <Button label="Add" size="small" onClick={onButtonClick} />
      </S.Wrapper>
    </S.Item>
  )
}
